<template>
  <div class="event-calendar__card">
    <div class="event-calendar__iframe-wrapper">
      <div
        class="meetings-iframe-container event-calendar__iframe"
        :data-src="iframeSource"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  iframeSource: string
}

defineProps<Props>()
</script>

<style scoped lang="scss">
.event-calendar {
  &__card {
    width: 100%;
    padding: 30px;
    background-color: white;
    border-radius: 16px;

    @media (min-width: $breakpoint-md) {
      padding: 60px 40px;
    }
  }

  &__iframe-wrapper {
    overflow: hidden;
    max-width: 850px;
    margin: 0 auto;
    height: 610px;

    @media (min-width: 835px) {
      height: 633px;
    }
  }
}
</style>
